module.exports = __webpack_public_path__ + "img/example-twitter-payload.f8095452.png";